
import { inject, type InjectionKey } from 'vue'
import * as CookieConsent from 'vanilla-cookieconsent'

export const CookieConsentKey: InjectionKey<typeof CookieConsent> = Symbol('CookieConsent')

export function useCookieConsent() {
  const cookieConsent = inject(CookieConsentKey)

  if (!cookieConsent) {
    throw new Error('CookieConsent plugin is not properly injected.')
  }

  return cookieConsent
}
